// extracted by mini-css-extract-plugin
module.exports = {"alert":"vugVUfwWSqHYEP5r1HVCj","link":"_53U-BX-ID70KC4Lc0mVYe","inner":"_3Qp_3Roi1O8ouwcgf-Z1sk","buttonClose":"ZVIhSczhNdGlidqDAYVex"};